/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=654206ec&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=654206ec&lang=scss"

import exportComponent from "/root/workspace/estate-mobile_TiQu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__